import { Component, ElementRef, OnInit } from '@angular/core';
import { CellEditorStoreService } from '../../cell-editor-store.service';
import { BorderRadiuses, ContentElement, ContentStatusEnum, GridCell, RowCell, SectionData } from '@urbannex/storethemes';
import { ChangeContext, Options } from '@angular-slider/ngx-slider';
import { SectionBuilderStoreService } from '../../sections-editor/shared-section-builder/section-builder-store.service';
import { EditState, InputField } from '../../../model';
import { CssServicesService } from '../../../services/css-services.service';
import { take } from 'rxjs';
import { NbIconConfig, NbIconLibraries } from '@nebular/theme';
import { sectionEditorIcons } from '../../dialogs/section-editor-dialog/section-dialog-menu-items';
import { SectionEditorStoreService } from '../section-editor-dialog/section-editor-store.service';

@Component({
  selector: 'kve-border-preset-popover',
  templateUrl: './border-preset-popover.component.html',
  styleUrls: ['./border-preset-popover.component.scss']
})
export class BorderPresetPopoverComponent implements OnInit {
  title: string;
  selectedRadiusClass: string;
  selectedWidth: any;
  borderBaseClass = "";
  content: any;
  status: ContentStatusEnum;
  /**
   * Passed in through the popOverContext
   */
  service: string;
  contentElements: ContentElement[];
  contentElement: ContentElement;
  /**
   * Passed in through the context
   */
  target: string;
  selectedCell: GridCell | RowCell;
  sectionData: SectionData

  color: string = "#222b45";
  colors: any[];

  field: InputField = {
    name: 'border',
    title: 'Border',
    type: '',
    controlType: 'border',
    value: undefined
  }

  borderRadiusClasses = [
    { name: "Border 1", class: "border-radius-1" },
    { name: "Border 2", class: "border-radius-2" },
    { name: "Border 3", class: "border-radius-3" },
    { name: "Border 4", class: "border-radius-4" },
    { name: "Border 5", class: "border-radius-5" },
    { name: "Border 6", class: "border-radius-6" },
    { name: "Border 7", class: "border-radius-7" },
    { name: "Border 8", class: "border-radius-8" },
  ]

  borderWidthClasses = [
    { name: "No Border", class: "none", cssValue: "0", value: "0" },
    { name: "Thin", class: "border-thin", cssValue: "1px", value: "1" },
    { name: "Medium Thin Border", class: "border-medium-thin", cssValue: "2px", value: "2" },
    { name: "Medium Border", class: "border-medium", cssValuelue: "3px", value: "3" },
    { name: "Medium Thick Border", class: "border-medium-thick", cssVvalue: "4px", value: "4" },
    { name: "Thick Border", class: "border-thick", cssValue: "5px", value: "5" },
    { name: "Fat Border", class: "border-fat", cssValue: "6px", value: "6" },
    { name: "Fat Border", class: "border-fat", cssValue: "7px", value: "7" },
    { name: "Fat Border", class: "border-fat", cssValue: "8px", value: "8" },
    { name: "Fat Border", class: "border-fat", cssValue: "9px", value: "9" },
    { name: "Fat Border", class: "border-fat", cssValue: "10px", value: "10" }
  ]
  value: number = 0;
  options: Options = {
    floor: 0,
    ceil: 20,
    step: 1
  }
  radiusOptions: Options = {
    floor: 0,
    ceil: 2,
    step: 0.25,
    vertical: true
  }
  radiusValue: number = 0;

  radiusIconConfig: NbIconConfig = { icon: 'border', pack: 'custom-icons' };
  widthIconConfig: NbIconConfig = { icon: 'width', pack: 'custom-icons' }
  colorIconConfig: NbIconConfig = { icon: 'border-color', pack: 'custom-icons' }

  borderString: string;
  borderRadiusString: string;

  constructor(
    private cellEditorStoreService: CellEditorStoreService,
    private sectionBuilderStoreService: SectionBuilderStoreService,
    private sectionEditorStoreService: SectionEditorStoreService,
    private cssServicesService: CssServicesService,
    private iconLibraries: NbIconLibraries,
    private el: ElementRef<HTMLElement>) {
    this.cellEditorStoreService.selectedCell$.subscribe(cell => {
      if (cell) {
        this.selectedCell = cell;
      }

    })
    this.sectionEditorStoreService.sectionData$.subscribe(sectionData => {
      if (sectionData) {
        this.sectionData = sectionData;
      }
    })
  }

  ngOnInit(): void {
    this.iconLibraries.registerSvgPack('custom-icons', sectionEditorIcons)
    /**
     * Populate existing takeOnValues or supply default values when they don't exist
     */

    if (this.service) {
      console.log(this.service);
      switch (this.service) {
        case "cellEditorStoreService":
          if (!this.selectedCell) return
          if (this.target && (this.target == "content" || this.target == "contentElement" || this.target == "parent")) {
            // Make sure there's a contentElement
            this.cellEditorStoreService.activeSelector$.subscribe((contentElement) => {
              if (contentElement) {
                this.contentElement = contentElement
              } else {
                if (this.selectedCell && this.selectedCell.contentElements) {
                  this.contentElement = this.selectedCell.contentElements[0];
                }
              }
              console.log(this.contentElement);
            })
            if (this.target == "content" || this.target == "contentElement") {
              this.borderString = this.contentElement.border ? this.contentElement.border : "";
            } else if (this.target == "parent") {
              this.borderString = this.contentElement.parentBorder ? this.contentElement.parentBorder : "";
            }
          } else if (this.target && (this.target == "cell" || this.target == "self")) {
            this.borderString = this.selectedCell.border;
          }
          if (this.borderString == "" || this.borderString == undefined) {
            this.borderString = this.createPropertyString("border")
            console.log(this.borderString)
          } if (this.borderRadiusString == "" || this.borderRadiusString == undefined) {
            this.borderRadiusString = this.createPropertyString("radius")
            console.log(this.borderRadiusString)
          }
          break;
        case "sectionEditorStoreService":
          break;
      }

    }
    /**
     * This gets the service from the status
     */
    if (this.status && this.service) {
      console.log(this.status)
      switch (this.status) {
        case ContentStatusEnum.CTNT_INITIAL_DRAFT:
          this.service = "sectionBuilder";
          this.sectionBuilderStoreService.selectedCell$.subscribe((cell: GridCell | RowCell) => {
            const contentElements = cell.contentElements;
            this.contentElement = contentElements.find(element => element.elId == this.content.elId);
          })
          break;
        case ContentStatusEnum.CTNT_FINAL_DRAFT:
          this.service = "cellEditor";
          this.cellEditorStoreService.contentElements$.subscribe((contentElements: ContentElement[]) => {
            this.contentElement = contentElements.find(element => element.elId == this.content.elId);
          })
          break;
        default:
          this.service = "cellEditor"
          break;
      }
    } else if (this.service) {
      console.log(this.service)
    }

    console.log(this.content);
    const popoverContainer: HTMLElement = this.el.nativeElement.closest('NB-POPOVER');
    if (popoverContainer) {
      popoverContainer.style.borderColor = "#808186";
    }
    this.selectedWidth = this.borderWidthClasses[0];
    // console.log(this.content.selector);
    if (this.content) {
      const valueString = this.content.borderWidth ? this.content.borderWidth : 0;
      if (valueString != 0) {
        this.value = valueString.replace(/\D/g, '');
      } else {
        this.value == 0;
      }
    }
    if (this.contentElement) {
      if (this.contentElement.borderColor == undefined && this.contentElement.color != undefined) {
        this.contentElement.borderColor = this.contentElement.color;
      }
    }
    this.cssServicesService.getTextColor().subscribe(color => {
      this.color = color;
      // console.log(this.textColor);
      console.log(this.colors);
    })
    this.setColors();


  }
  /**
   *
   * @param property "border" || "borderRadius"
   * @returns the propertyString which is either borderString or borderRadiusString
   */

  createPropertyString(property: string): string {
    console.log("Creating css property string")
    let propertyString = "";
    let propertyWidth = "0px";
    let propertyRadius = "0px";
    let propertyStyle = "solid";
    let propertyColor = "transparent";
    if (property == "border") {
      console.log(property, this.service, this.target)
      if (this.service == "cellEditorStoreService") {
        switch (this.target) {
          case "cell":
          case "self":
            if (this.selectedCell) {
              propertyWidth = this.selectedCell.borderWidth ? this.selectedCell.borderWidth : "0px";
              propertyStyle = this.selectedCell.borderStyle ? this.selectedCell.borderStyle : "solid";
              propertyColor = this.selectedCell.borderColor ? this.selectedCell.borderColor : propertyColor;
            }
            break;
          case "content":
          case "contentElement":
            if (this.contentElement) {
              propertyWidth = this.contentElement.borderWidth ? this.contentElement.borderWidth : "0px";
              propertyStyle = this.contentElement.borderStyle ? this.contentElement.borderStyle : "solid";
              propertyColor = this.contentElement.borderColor ? this.contentElement.borderColor : propertyColor;
            }
            break
          case "parent":
            if (this.contentElement) {
              propertyWidth = this.contentElement.parentBorderWidth ? this.contentElement.parentBorderWidth : "0px";
              propertyStyle = this.contentElement.parentBorderStyle ? this.contentElement.parentBorderStyle : "solid";
              propertyColor = this.contentElement.parentBorderColor ? this.contentElement.parentBorderColor : propertyColor;
            }
            break;
          default:
            console.log("No case found for target :" + this.target)
            break;
        }
      } else if (this.service == "sectionEditorStoreService") {
        switch (this.target) {
          case "self":
          case "section":
            if (this.sectionData) {
              propertyWidth = this.sectionData.borderWidth ? this.sectionData.borderWidth : "0px";
              propertyStyle = this.sectionData.borderStyle ? this.sectionData.borderStyle : "solid";
              propertyColor = this.sectionData.borderColor ? this.sectionData.borderColor : propertyColor;
            }
            break;
          case "content":
          case "contentElement":
            if (this.sectionData && this.sectionData.title) {
              const title: ContentElement = this.sectionData.title;
              propertyWidth = title.borderWidth ? title.borderWidth : "0px";
              propertyStyle = title.borderStyle ? title.borderStyle : "solid";
              propertyColor = title.borderColor ? title.borderColor : propertyColor;
            }
            break;

          default:
            break;
        }
      }
      propertyString = `${propertyWidth} ${propertyStyle} ${propertyColor}`
    } else if (property == "radius") {
      if (this.service == "cellEditorStoreServcie") {
        switch (this.target) {
          case "cell":
          case "self":
            if (this.selectedCell) {
              propertyRadius = this.selectedCell.borderRadius ? this.selectedCell.borderRadius : propertyRadius;
            }
            break;
          case "content":
          case "contentElement":
            if (this.contentElement) {
              propertyRadius = this.contentElement.borderRadius ? this.contentElement.borderRadius : propertyRadius;
            }
            break
          case "parent":
            if (this.contentElement) {
              propertyRadius = this.contentElement.parentBorderRadius ? this.contentElement.parentBorderRadius : propertyRadius;
              // propertyStyle = this.contentElement.parentBorderStyle?this.contentElement.parentBorderStyle:"solid";
              // propertyColor = this.contentElement.parentBorderColor?this.contentElement.parentBorderColor:propertyColor;
            }
            break;

          default:
            break;
        }
      } else if (this.service == "sectionEdotorStoreService") {
        switch (this.target) {
          case "self":
          case "section":
            if (this.sectionData) {
              propertyRadius = this.sectionData.borderRadius ? this.sectionData.borderRadius : propertyRadius;
            }
            break;
          case "content":
          case "contentElement":
            if (this.sectionData && this.sectionData.title) {
              const title: ContentElement = this.sectionData.title;
              propertyRadius = title.borderRadius ? title.borderRadius : propertyRadius;
            }
            break;

          default:
            break;
        }
      }
      propertyString = `${propertyRadius}`
    }
    console.log("propertyString:" + `${propertyString}`)
    return propertyString;
  }



  onWidthChange(e) {
    console.log(e)
    this.contentElement.borderWidth = e.value;

    if (this.service == "cellEditor" || this.service == "cellEditorStoreService") {
      this.cellEditorStoreService.updateActiveSelector(this.contentElement);
      this.cellEditorStoreService.updateSelectorPosChange(e.value);
    } else if (this.service == "sectionBuilder" || this.service == "sectionEditorStoreSevice") {
      this.sectionBuilderStoreService.updateContent(this.contentElement);
    }
  }

  onBorderSelect(borderClass) {
    console.log(borderClass);
    this.selectedRadiusClass = borderClass.class;
    this.borderRadiusClasses.forEach(borderRadius => {
      if (this.contentElement.classes.includes(borderRadius.class)) {
        const itmIndx = this.contentElement.classes.indexOf(borderRadius.class);
        if (itmIndx !== -1) {
          console.log("Removing classes")
          this.contentElement.classes.splice(itmIndx, 1);
        }
      }
    })
    console.log({ content: this.content, choice: borderClass.class });
    this.contentElement.classes.push(borderClass.class);
    if (this.service == "cellEditor") {
      this.cellEditorStoreService.updateActiveSelector(this.contentElement);
      this.cellEditorStoreService.updateSelectorPosChange(borderClass.class);
    } else if (this.service == "sectionBuilder") {
      this.sectionBuilderStoreService.updateContent(this.contentElement);
      this.sectionBuilderStoreService.updateEditState(EditState.UPDATED);
    }

  }

  onApply() {
    console.log({ SelectedRadius: this.selectedRadiusClass, SelectedWidth: this.selectedWidth })
    const radiusClass = this.selectedRadiusClass;
    const widthClass = this.selectedWidth.class;
    this.cellEditorStoreService.contentElements$.subscribe((contentElements: ContentElement[]) => {
      const contentElement = contentElements.find(element => element.elId == this.content.elId);
      contentElement.classes.push(radiusClass); // = BorderRadiuses[radiusClass];
      contentElement.classes.push(widthClass);
      contentElement.classes.push("kve-border");
      this.cellEditorStoreService.updateContentElements(contentElements);
    })
    /* switch (this.content.selector) {
      case "header":
        this.cellEditorStoreService.updateHdrBorderRdsCls(radiusClass)
        this.cellEditorStoreService.updateHdrBorderWdtCls(widthClass)
        break;
      case "footer":
        this.cellEditorStoreService.updateFtrBorderRdsCls(radiusClass)
        this.cellEditorStoreService.updateFtrBorderWdtCls(widthClass)
        break;
      case "banner-text":
        this.cellEditorStoreService.updateTxtBorderRdsCls(radiusClass)
        this.cellEditorStoreService.updateTxtBorderWdtCls(widthClass)
        break;
      default:
        break;
    } */
  }

  onUserChange(changeContext: ChangeContext) {
    if (this.service == "sectionBuilder") {
      this.sectionBuilderStoreService.updateEditState(EditState.EDITING);
    }
    console.log(changeContext.value);
    // this.marginBottom = changeContext.value;
  }
  onUserChangeStart(changeContext: ChangeContext) {
    console.log({ start: changeContext.value })
  }

  onUserChangeEnd(changeContext: ChangeContext) {
    console.log({ end: changeContext.value });
    this.contentElement.borderWidth = changeContext.value + "px";
    if (this.service == "cellEditor") {
      this.cellEditorStoreService.updateActiveSelector(this.contentElement);
      this.cellEditorStoreService.updateSelectorPosChange(changeContext.value + "px");
    } else if (this.service == "sectionBuilder") {
      this.sectionBuilderStoreService.updateContent(this.contentElement);
      this.sectionBuilderStoreService.updateEditState(EditState.UPDATED);
    }
  }
  onVertUserChange(changeContext: ChangeContext) {
    console.log(changeContext.value);
    // this.marginBottom = changeContext.value;
  }
  onVertUserChangeStart(changeContext: ChangeContext) {
    console.log({ start: changeContext.value })
    this.sectionBuilderStoreService.updateEditState(EditState.EDITING)
  }
  onVertUserChangeEnd(changeContext: ChangeContext) {
    this.contentElement.borderRadius = changeContext.value + "rem";
    if (this.service == "cellEditor") {
      this.cellEditorStoreService.updateActiveSelector(this.contentElement);
      // this.cellEditorStoreService.updateSelectorPosChange(e.value);
    } else if (this.service == "sectionBuilder") {
      this.sectionBuilderStoreService.updateContent(this.contentElement);
    }
    this.sectionBuilderStoreService.updateEditState(EditState.UPDATED)
    /*
        this.cellEditorStoreService.contentElements$.subscribe((contentElements:ContentElement[]) => {
          let contentElement = contentElements.find(element => element.elId == this.content.elId);
    
          this.cellEditorStoreService.updateContentElements(contentElements);
          this.cellEditorStoreService.updateSelectorPosChange(changeContext.value+"rem");
        }) */
  }

  handleChangeComplete(e) {
    this.handleColorPick(e);
  }

  handleColorPick(e) {
    if (e.color.rgb.a < 1) {
      this.color = "rgb(" + e.color.rgb.r + "," + e.color.rgb.g + "," + e.color.rgb.b + "," + e.color.rgb.a + ")";
    } else {
      this.color = e.color.hex;
    }
    console.log(this.color, this.service)
    // update the borderString if it exists
    switch (this.service) {
      case "cellEditorStoreService":
        this.handleCellColorPick();
        break;
      case "sectionEditorStoreSevice":
        this.handleSectionColorPick();
        break;

      default:
        break;
    }
    // console.log("Service: ",this.service, "Target: ",this.target," Property: ",this.property);
    // Handle color change for content elements
    // At this stage we have the service, target and property defined
    /**
     *  Sort out the issue with content - where the target is content
     * The issue arises because updating content element color properties can be handeled in both section and cell context
     *
     * */
    /* if(this.service === "sectionEditorStoreService" || this.service === "cellEditorStoreService" && this.target === "content"){
      console.log("Section Editor Store Service color change");
      if(this.content == undefined || this.content == null){
        console.log("No content element defined - cannot set color");
        return
      }else{
        this.handleContentColorChange(this.service,this.content)
      }
    }else if(this.target !== "content"){
      this.handleContainerColorChange(this.service,this.property)
    } */

  }

  setColors(): void {
    const bgBasic: string[] = [];
    const bgPrimary: string[] = [];
    const bgAlt: string[] = [];
    const primaryColors: string[] = [];
    this.cssServicesService.getBgColors().pipe(take(1)).subscribe((colorKV: any[]) => {
      // console.log(colorKV);
      colorKV.forEach((colorObj, i) => {
        if (i < 4) {
          bgBasic.push(colorObj.val)
        } else if (i > 3 && i < 8) {
          bgPrimary.push(colorObj.val)
        } else if (i > 7) {
          bgAlt.push(colorObj.val)
        }

      })
      this.cssServicesService.getPmColors().pipe(take(1))
        .subscribe((colorKV: any[]) => {
          // console.log(colorKV)
          colorKV.forEach((colorObj) => {
            primaryColors.push(colorObj.val)
          })
          this.colors = bgBasic.concat(primaryColors).concat(bgAlt);
          console.log(this.colors)
        })
    });


  }

  onBorderChange(e) {
    console.log(e, this.service, this.target)
    switch (this.service) {
      case "sectionEditorStoreService":
        this.sectionEditorStoreService.sectionData$.pipe(take(1)).subscribe(sectionData => {
          const updatedSectionData: SectionData = { ...sectionData, border: e }
          this.sectionEditorStoreService.updateSectionData({ ...updatedSectionData })
        })
        break;
      case "cellEditorStoreService":
        switch (this.target) {
          case "self":
          case "cell":
            console.log("updating border for cell")
            this.cellEditorStoreService.selectedCell$.pipe(take(1)).subscribe(cell => {
              const updatedCell: RowCell | GridCell = { ...cell, border: e }
              console.log("cell-editor-store.service.ts - updating selected cell cellVerticalAlign: " + updatedCell);
              this.cellEditorStoreService.updateSelectedCell({ ...updatedCell })
            })
            break;
          case "content":
            /**
             * Routine to ensure that a contentElement is present.
             */
            let contentElement;
            this.cellEditorStoreService.activeSelector$.pipe(take(1)).subscribe(content => {
              /**
               * If there is no content element active in the store, check for contentElements and select the first
               * If the are no contentElements in the store, check for selectedCell, get the contentElements and select the first
               */
              if (!content) {
                if (this.contentElements && this.contentElements.length > 0) {
                  contentElement = this.contentElement[0];
                } else {
                  this.cellEditorStoreService.contentElements$.subscribe(contentElements => {
                    contentElement = contentElements[0];
                  })
                }
                if (contentElement == undefined) {
                  this.cellEditorStoreService.selectedCell$.subscribe(cell => {
                    if (cell) {
                      const contentElements = cell.contentElements;
                      if (contentElements && contentElements.length > 0)
                        contentElement = contentElements[0]
                    }
                  })
                }
              } else {
                /**
                 * There is an active contentElement in the store
                 */
                contentElement = Object.assign(content);
              }

              const updatedContent: ContentElement = { ...contentElement, border: e }
              console.log(updatedContent)
              this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(updatedContent);
              /* this.cellEditorStoreService.updateActiveSelector(updatedContent);
              let updatedContentElements:ContentElement[];
              let selectedCell:GridCell | RowCell;
              this.cellEditorStoreService.selectedCell$.subscribe(cell => {
                selectedCell = cell;
                updatedContentElements = cell.contentElements.map(contentElement =>
                  contentElement.elId === updatedContent.elId ? contentElement : updatedContent
                );
              })
              let updateCell = {...selectedCell,updatedContentElements}
              console.log(updateCell)
              this.cellEditorStoreService.updateSelectedCell(updateCell) */

            })
            break;

          case "parent":
            console.log("Hitting parent border update - border: " + e);
            this.cellEditorStoreService.activeSelector$.pipe(take(1)).subscribe(_content => {
              console.log("content to be updated: " + _content.parentBorder);
              const updatedContent: ContentElement = { ..._content, parentBorder: e };
              console.log(updatedContent)
              this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(updatedContent);
              // this.cellEditorStoreService.updateActiveSelector({...updatedContent})
            })
            break
          default:
            break;
        }
        break;

      default:
        break;
    }
  }
  onBorderRadiusChange(e) {
    console.log(e, this.service)
    switch (this.service) {
      case "sectionEditorStoreService":
        this.sectionEditorStoreService.sectionData$.pipe(take(1)).subscribe(sectionData => {
          const updatedSectionData: SectionData = { ...sectionData, borderRadius: e }
          this.sectionEditorStoreService.updateSectionData({ ...updatedSectionData })
        })
        break;
      case "cellEditorStoreService":
        switch (this.target) {
          case "self":
          case "cell":
            this.cellEditorStoreService.selectedCell$.pipe(take(1)).subscribe(cell => {
              const updatedCell: RowCell | GridCell = { ...cell, borderRadius: e }
              console.log("cell-editor-store.service.ts - updating selected cell cellVerticalAlign: " + updatedCell);
              this.cellEditorStoreService.updateSelectedCell({ ...updatedCell })
            })
            break;
          case "content":
          case "contentElement":
            console.log("target = " + this.target)
            this.cellEditorStoreService.activeSelector$.pipe(take(1)).subscribe(content => {
              console.log("content to be updated: " + content);
              const updatedContent: ContentElement = { ...content, borderRadius: e }
              this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(updatedContent);
              // this.cellEditorStoreService.updateActiveSelector({...updatedContent})
            })
            break;

          default:
            break;
        }
        break;

      default:
        break;
    }
  }

  handleCellColorPick() {
    if (!this.target) {
      return
    }
    console.log("Handle cell border color pick - with target: " + this.target)
    // First update the borderString with the latest value from the store
    this.cellEditorStoreService.selectedCell$.pipe(take(1)).subscribe(_selectedCell => {
      if (_selectedCell && _selectedCell.border) {
        this.borderString = _selectedCell.border;
      }
    })
    this.borderString = this.updateBorderColor(this.borderString, this.color)
    console.log("BorderString after color replacement: " + this.borderString)
    if (this.target == "content" || this.target == "contentElement" || this.target == "parent") {
      if (this.target == "content" || this.target == "contentElement") {
        this.cellEditorStoreService.activeSelector$.pipe(take(1)).subscribe(content => {
          console.log("content to be updated: " + content);
          const updatedContent: ContentElement = { ...content, border: this.borderString }
          this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(updatedContent);
          // this.cellEditorStoreService.updateActiveSelector({...updatedContent})
        })
      } else if (this.target == "parent") {
        this.cellEditorStoreService.activeSelector$.pipe(take(1)).subscribe(content => {
          // Get the existing parentBorder value and replace the color
          const borderString = content.parentBorder ? content.parentBorder : this.borderString;
          this.borderString = this.updateBorderColor(borderString, this.color)
          console.log({ BeforeContent: content, parentBorder: this.borderString });
          content.parentBorder = this.borderString;
          const updatedContent: ContentElement = { ...content }
          this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(updatedContent);
          // this.cellEditorStoreService.updateActiveSelector({...updatedContent})
        })
      }
    } else if (this.target == "cell" || this.target == "self") {
      console.log("Updating cell border")
      this.cellEditorStoreService.selectedCell$.pipe(take(1)).subscribe(cell => {
        const updateCell = { ...cell, border: this.borderString }
        console.log("cell-editor-store.service.ts - updating selected cell border: " + updateCell);
        this.cellEditorStoreService.updateSelectedCell(updateCell);
      })

    }
  }

  handleSectionColorPick() {
    if (!this.target) {
      return
    }
    console.log("Handle cell border color pick - with target: " + this.target)
    this.borderString = this.updateBorderColor(this.borderString, this.color)
    if (this.target == "section" || this.target == "self" || this.target == "content") {
      this.sectionEditorStoreService.sectionData$.subscribe((sectionData: SectionData) => {
        const updatedSectionData: SectionData = { ...sectionData, border: this.borderString };
        this.sectionEditorStoreService.updateSectionData(updatedSectionData)
      })
    } else if (this.target == "content" || this.target == "contentElement" || this.target == "title") {
      this.sectionEditorStoreService.sectionData$.subscribe((sectionData: SectionData) => {
        const title = sectionData.title;
        if (title) {
          const updatedTitle = { ...title, border: this.borderRadiusString };
          this.sectionEditorStoreService.updateSectionData({ ...sectionData, title: updatedTitle })
        }
      })
    }

  }

  updateBorderColor(borderString, color) {
    console.log("BorderString before color replacement: " + borderString)
    // Match hex colors (#fff, #ffffff), rgb/rgba, hsl/hsla, and named colors
    const colorPattern = /(#[0-9a-fA-F]{3,8}|rgba?\([^)]+\)|hsla?\([^)]+\)|[a-z]+)$/i;

    // Replace the last color value in the border string with the new color
    return borderString.replace(colorPattern, color);
  }

}
